module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#F8F8F8"
    }
  }, [_c('div', {
    staticClass: "info-card-content"
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingHistory')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "315px",
      "overflow-y": "auto"
    },
    attrs: {
      "id": "leaderboard"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.date')))]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.numberOfPoints')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.rating')))])]), _vm._v(" "), _vm._l((_vm.ratingHistory.slice().reverse()), function(izpit, i) {
    return _c('tr', {
      staticClass: "history-cell",
      on: {
        "click": function($event) {
          return _vm.showResultsForOneExam(izpit.examAttemptId)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(new Date(izpit.date).toLocaleString('default', {
      day: 'numeric',
      month: 'short'
    })))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "progress-container"
    }, [(izpit.points / izpit.maxPoints >= 0.75) ? _c('div', {
      staticClass: "progress",
      style: ('background-color: #00a65a; width:' + (100 * izpit.points / izpit.maxPoints) + '%')
    }) : (izpit.points / izpit.maxPoints >= 0.25) ? _c('div', {
      staticClass: "progress",
      style: ('background-color: #f39c12; width:' + (100 * izpit.points / izpit.maxPoints) + '%')
    }) : _c('div', {
      staticClass: "progress",
      style: ('background-color: #dd4b39; width:' + (100 * izpit.points / izpit.maxPoints) + '%')
    })])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-blue"
    }, [_vm._v(_vm._s(izpit.points.toFixed(1) + '/' + izpit.maxPoints))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(izpit.newRating))])])
  })], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bb4f521", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb4f521"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/RatingHistoryCard.vue
// module id = 1435
// module chunks = 1